import { useContext } from 'react';
import { DimensionsContext } from 'providers';

export default () => {
  const dimensionsContext = useContext(DimensionsContext);
  return dimensionsContext.dimensions;
};
